import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPlay = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M19.097 13.472a1.75 1.75 0 0 0 0-2.944L7.947 3.36c-1.165-.75-2.697.087-2.697 1.472v14.336c0 1.385 1.532 2.221 2.696 1.472zm-.811-1.682a.25.25 0 0 1 0 .42L7.136 19.38a.25.25 0 0 1-.386-.21V4.831a.25.25 0 0 1 .385-.21z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgPlay;
